var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompanyReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3707 2.26026C9.53762 2.09361 9.76398 2 10 2C10.236 2 10.4624 2.09361 10.6293 2.26026L15.9699 7.59365L17.7501 9.37145C17.9123 9.5391 18.002 9.76364 18 9.99671C17.9979 10.2298 17.9043 10.4527 17.7393 10.6175C17.5743 10.7823 17.351 10.8758 17.1176 10.8778C16.8842 10.8799 16.6594 10.7903 16.4915 10.6284L16.2307 10.3679V16.2222C16.2307 16.6937 16.0432 17.1459 15.7093 17.4793C15.3755 17.8127 14.9227 18 14.4505 18H11.7802C11.5441 18 11.3177 17.9063 11.1508 17.7396C10.9839 17.5729 10.8901 17.3469 10.8901 17.1111V14.4444H9.1099V17.1111C9.1099 17.3469 9.01612 17.5729 8.84919 17.7396C8.68226 17.9063 8.45586 18 8.21979 18H5.54948C5.07734 18 4.62454 17.8127 4.29068 17.4793C3.95683 17.1459 3.76927 16.6937 3.76927 16.2222V10.3679L3.50847 10.6284C3.34059 10.7903 3.11575 10.8799 2.88237 10.8778C2.64899 10.8758 2.42574 10.7823 2.26071 10.6175C2.09567 10.4527 2.00206 10.2298 2.00003 9.99671C1.99801 9.76364 2.08772 9.5391 2.24986 9.37145L4.03007 7.59365L9.3707 2.26026Z",
    fill: "#F8B407"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompanyReserve);
export default __webpack_public_path__ + "static/media/ic-company-reserve.c624ce9a57d7c5d9417b6ef75cf1e29f.svg";
export { ForwardRef as ReactComponent };